window.theme = window.theme || {};
theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');
        constructor = constructor || this.constructors[type];
        if (typeof constructor === 'undefined') {
            return;
        }
        var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container
        });
        this.instances.push(instance);
    },
    _onSectionLoad: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },
    _onSectionUnload: function(evt) {
        this.instances = this.instances.filter(function(instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
            if (isEventInstance && typeof instance.onUnload === 'function') {
                instance.onUnload(evt);
            }
            return !isEventInstance;
        });
    },
    _onSelect: function(evt) {
        var instance = this.instances.find(function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(evt);
        }
    },
    _onDeselect: function(evt) {
        var instance = this.instances.find(function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(evt);
        }
    },
    _onBlockSelect: function(evt) {
        var instance = this.instances.find(function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(evt);
        }
    },
    _onBlockDeselect: function(evt) {
        var instance = this.instances.find(function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(evt);
        }
    },
    register: function(type, constructor) {
        this.constructors[type] = constructor;
        $('[data-section-type=' + type + ']').each(function(index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

window.theme = theme || {};
// RecoverPassword Page Login
theme.customerTemplates = (function() {
    function initEventListeners() {
        // Show reset password form
        $('#RecoverPassword').on('click', function(evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });

        // Hide reset password form
        $('#HideRecoverPasswordLink').on('click', function(evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        });
    }

    /* Show/Hide recover password form */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /* Show reset password success message */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
          return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }

    /* Show/hide customer address forms */
    function customerAddressForm() {
        var $newAddressForm = $('#AddressNewForm');

        if (!$newAddressForm.length) {
          return;
        }

        // Initialize observers on address selectors, defined in shopify_common.js
        if (Shopify) {
            // eslint-disable-next-line no-new
            new Shopify.CountryProvinceSelector(
                'AddressCountryNew',
                'AddressProvinceNew',
                {
                  hideElement: 'AddressProvinceContainerNew'
                }
            );
        }

        // Initialize each edit form's country/province selector
        $('.address-country-option').each(function() {
            var formId = $(this).data('form-id');
            var countrySelector = 'AddressCountry_' + formId;
            var provinceSelector = 'AddressProvince_' + formId;
            var containerSelector = 'AddressProvinceContainer_' + formId;

            // eslint-disable-next-line no-new
            new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
                hideElement: containerSelector
            });
        });

        // Toggle new/edit address forms
        $('.address-new-toggle').on('click', function() {
            $newAddressForm.toggleClass('hide');
        });

        $('.address-edit-toggle').on('click', function() {
            var formId = $(this).data('form-id');
            $('#EditAddress_' + formId).toggleClass('hide');
        });

        $('.address-delete').on('click', function() {
            var $el = $(this);
            var formId = $el.data('form-id');
            var confirmMessage = $el.data('confirm-message');

            // eslint-disable-next-line no-alert
            if (
                confirm(
                    confirmMessage || 'Are you sure you wish to delete this address?'
                )
            ) {
                Shopify.postLink('/account/addresses/' + formId, {
                    parameters: { _method: 'delete' }
                });
            }
        });
    }

    /* Check URL for reset password hash */
    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
          toggleRecoverPasswordForm();
        }
    }

    return {
        init: function() {
            checkUrlHash();
            initEventListeners();
            resetPasswordSuccess();
            customerAddressForm();
        }
    };
})();
// RecoverPassword Popup Index
theme.customerloginTemplates = (function() {
    function initEventsListeners() {
        // Show reset password form
        $('#RecoversPassword').on('click', function(evt) {
            evt.preventDefault();
            toggleRecoverPasswordFormIndex();
        });

        // Hide reset password form
        $('#HideRecoverPasswordIndex').on('click', function(evt) {
            evt.preventDefault();
            toggleRecoverPasswordFormIndex();
        });
    }

    /* Show/Hide recover password form */
    function toggleRecoverPasswordFormIndex() {
        $('#RecoverPasswordFormIndex').slideToggle('fast');
    }
    return {
        init: function() {
            initEventsListeners();
        }
    };
})();
window.theme = window.theme || {};
theme.Nov_Slickcarousel = (function() {
    function Nov_Slickcarousel() {
        $('[data-section-type="nov-slick"]').each(function (argument) {
            var el = $(this);
            var sectionId = el.attr('data-section-id');
            var slider = el.find('.nov-slick-carousel');
            var rtl = $('html').hasClass('lang-rtl');
            var items_xxl = slider.data("items_xxl"),
                items_xl = slider.data("items_xl"),
                items_lg = slider.data("items_lg"),
                items_md = slider.data("items_md"),
                items_sm = slider.data("items_sm"),
                items_xs = $(slider).data("items_xs") ? $(slider).data("items_xs") : 1,
                row_mobile = $(slider).data("row_mobile") ? $(slider).data("row_mobile") : 1,
                vertical = slider.data("vertical"),
                vertical_xl = slider.data("vertical_xl"),
                vertical_lg = slider.data("vertical_lg"),
                vertical_md = slider.data("vertical_md"),
                vertical_sm = slider.data("vertical_sm"),
                vertical_xs = slider.data("vertical_xs"),
                navfor = slider.data("navfor") ? slider.data("navfor"): false,
                appenddots = el.find('.append-dots'),
                isSliding = false;
            if (vertical == true) {
                rtl = false;
            }
    
            function getRows() {
                var w = window.innerWidth;
                if (w < 576) return row_mobile;
                if (w < 768) return row_mobile;
                if (w < 992) return slider.data("row_md") ? 1 : slider.data("row");
                if (w < 1200) return slider.data("row_lg") ? 1 : slider.data("row");
                return slider.data("row");
            }
    
            function initSlick() {
                if (slider.hasClass('slick-initialized')) {
                    slider.slick('destroy');
                }
    
                slider.slick({
                    nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
                    prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
                    slidesToShow: items_xxl,
                    slidesToScroll: slider.data("oneslider") ? slider.data("oneslider") : items_xxl,
                    rows: getRows(),
                    arrows: slider.data("nav"),
                    dots: slider.data("dots"),
                    infinite: slider.data("loop"),
                    fade: slider.data("fade"),
                    speed: slider.data("speed"),
                    autoplay: slider.data("autoplay"),
                    autoplaySpeed: slider.data("autoplaytimeout"),
                    pauseOnFocus: slider.data("focus"),
                    pauseOnHover: slider.data("hover"),
                    centerMode: slider.data("center"),
                    cssEase: slider.data("cssease"),
                    swipe: slider.data("swipe"),
                    focusOnSelect: slider.data("focusonselect"),
                    rtl: rtl,
                    vertical: vertical,
                    verticalSwiping: vertical,
                    appendDots: appenddots.length ? appenddots : slider,
                    asNavFor: navfor,
                    responsive: [
                        {
                            breakpoint: 1441,
                            settings: {
                                slidesToShow: items_xl,
                                slidesToScroll: slider.data("oneslider") ? 1 : items_xl,
                                vertical: vertical_xl,
                                verticalSwiping: vertical_xl
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: items_lg,
                                slidesToScroll: slider.data("oneslider") ? 1 : items_lg,
                                vertical: vertical_lg,
                                verticalSwiping: vertical_lg
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: items_md,
                                slidesToScroll: slider.data("oneslider") ? 1 : items_md,
                                vertical: vertical_md,
                                verticalSwiping: vertical_md
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: items_sm,
                                slidesToScroll: slider.data("oneslider") ? 1 : items_sm,
                                vertical: vertical_sm,
                                verticalSwiping: vertical_sm
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: items_xs,
                                slidesToScroll: slider.data("oneslider") ? 1 : items_xs,
                                vertical: vertical_xs,
                                verticalSwiping: vertical_xs
                            }
                        }
                    ]
                });
    
                var currentSlide = slider.slick('slickCurrentSlide');
                if (slider.find('.slick-cloned').length == 0) {
                    checkArrow(slider, currentSlide);
                }
                checkClasses(slider);
    
                bindSlickEvents();
            }
    
            function checkClasses(class_parent) {
                var total = $('.slick-list .slick-active', class_parent).length;
                $('.slick-list .slick-slide', class_parent).removeClass('firstActiveItem lastActiveItem');
                $('.slick-list .slick-active', class_parent).each(function (index) {
                    if (index === 0 && rtl === false) {
                        $(this).addClass('firstActiveItem');
                    } else if (index === 0 && rtl === true) {
                        $(this).addClass('lastActiveItem');
                    }
                    if (index === total - 1 && total > 1 && rtl === false) {
                        $(this).addClass('lastActiveItem');
                    } else if (index === total - 1 && total > 1 && rtl === true) {
                        $(this).addClass('firstActiveItem');
                    }
                });
            }
    
            function checkArrow(el, current) {
                var num = $(el).find('.slick-slide').length,
                    num_act = $(el).find('.slick-slide.slick-active').length,
                    prev = $(el).parents('#shopify-section-' + sectionId).find('.nav-prev'),
                    next = $(el).parents('#shopify-section-' + sectionId).find('.nav-next');
                if (num - num_act == 0) {
                    prev.css('visibility', 'hidden');
                    next.css('visibility', 'hidden');
                } else {
                    prev.css('visibility', 'visible');
                    next.css('visibility', 'visible');
                }
                if (current == 0) {
                    prev.addClass('disabled');
                } else {
                    prev.removeClass('disabled');
                }
                if (num - num_act <= current) {
                    next.addClass('disabled');
                } else {
                    next.removeClass('disabled');
                }
            }
    
            function bindSlickEvents() {
                $('.nav-prev', '#shopify-section-' + sectionId).off('click.slick').on('click.slick', function () {
                    slider.slick('slickPrev');
                });
                $('.nav-next', '#shopify-section-' + sectionId).off('click.slick').on('click.slick', function () {
                    slider.slick('slickNext');
                });
                $('.nov-slick-dot', '#shopify-section-' + sectionId).off('click.slick').on('click.slick', function (event) {
                    if (isSliding) return;
                    isSliding = true;
                    $('.nov-slick-dot', '#shopify-section-' + sectionId).removeClass('current');
                    $(this).addClass('current');
    
                    var goToPageIndex = $(this).data('index');
                    var slickOptions = slider.slick('slickGetOption', 'responsive');
                    var slidesToShow = slider.slick('slickGetOption', 'slidesToShow');
    
                    if (slickOptions && slickOptions.length > 0) {
                        for (var i = 0; i < slickOptions.length; i++) {
                            if (window.innerWidth <= slickOptions[i].breakpoint && slickOptions[i].settings.slidesToShow) {
                                slidesToShow = slickOptions[i].settings.slidesToShow;
                            }
                        }
                    }
    
                    var goToSlideIndex = goToPageIndex * slidesToShow;
                    slider.slick('slickGoTo', goToSlideIndex);
                    setTimeout(function () {
                        isSliding = false;
                    }, 100);
                });
    
                slider.off('beforeChange.slick').on('beforeChange.slick', function (event, slick, currentSlide, nextSlide) {
                    isSliding = true;
                    slider.addClass('sliding');
    
                    var slickOptions = slider.slick('slickGetOption', 'responsive');
                    var slidesToShow = slider.slick('slickGetOption', 'slidesToShow');
    
                    if (slickOptions && slickOptions.length > 0) {
                        for (var i = 0; i < slickOptions.length; i++) {
                            if (window.innerWidth <= slickOptions[i].breakpoint && slickOptions[i].settings.slidesToShow) {
                                slidesToShow = slickOptions[i].settings.slidesToShow;
                            }
                        }
                    }
    
                    var nextPageIndex = Math.floor(nextSlide / slidesToShow);
                    if ($('#shopify-section-' + sectionId).find('.nov-slick-dot').length > 0) {
                        $('#shopify-section-' + sectionId).find('.nov-slick-dot').removeClass('current');
                        $('#shopify-section-' + sectionId).find('.nov-slick-dot[data-index=' + nextPageIndex + ']').addClass('current');
                    }
                });
    
                slider.off('afterChange.slick').on('afterChange.slick', function (event, slick, currentSlide) {
                    isSliding = false;
                    slider.removeClass('sliding');
                    checkClasses(slider);
                    if (slider.data("loop") == false) {
                        checkArrow(slider, currentSlide);
                    }
                });
            }
    
            initSlick();
    
            var resizeTimer;
            var lastBreakpoint = getBreakpointZone();
    
            function getBreakpointZone() {
                var w = window.innerWidth;
                if (w < 576) return 'xs';
                if (w < 768) return 'sm';
                if (w < 992) return 'md';
                if (w < 1200) return 'lg';
                if (w < 1441) return 'xl';
                return 'xxl';
            }
    
            $(window).on('resize.slick-' + sectionId, function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    var currentBreakpoint = getBreakpointZone();
                    if (currentBreakpoint !== lastBreakpoint) {
                        lastBreakpoint = currentBreakpoint;
                        initSlick();
                    }
                }, 300);
            });
        });
    }
    return Nov_Slickcarousel;
})();
theme.Nov_SliderShow = (function() {
    function Nov_SliderShow(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var slideWrapper = (this.slideWrapper = '#shopify-section-' + sectionId + ' .main-slider');
        
        var rtl = $('html').hasClass('lang-rtl');

        var autoplay = $(slideWrapper).data('autoplay'),
            speed = $(slideWrapper).data('speed'),
            arrows = $(slideWrapper).data('arrows'),
            dots = $(slideWrapper).data('dots'),
            loadingBar = $(slideWrapper).data('loading-bar'),
            zoom = $(slideWrapper).data('zoom');
        $(function() {
            $(slideWrapper).on("init", function(slick) {
                slick = $(slick.currentTarget);
                if (autoplay == true && typeof loadingBar != "undefined") {
                    $(slideWrapper).find('.slick-current').addClass('loading-bar');
                }
                $(slideWrapper).find('.slick-current video').trigger('play');
                setTimeout(function() {
                    $(slideWrapper).find(".slick-current .slide-image").addClass("first-zoomin");
                    $(".slick-current .caption-animate", slideWrapper).each(function() {
                        var caption = $(this).data("animate");
                        $(this).addClass(caption);
                    });
                    if ($('#shopify-section-' + sectionId + ' .direction-dots').length) {
                        $('#shopify-section-' + sectionId + ' .direction-dots').addClass('act');
                    }
                }, 700);
            });
            $(slideWrapper).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                slick = $(slick.$slider);
                $(".slick-current .caption-animate", slideWrapper).each(function() {
                    var caption = $(this).data("animate");
                    $(this).removeClass(caption);
                });
                if (zoom == true) {
                    $(slideWrapper).find(".slick-current .slide-image").removeClass("zoom_img");
                }
                if (autoplay == true && typeof loadingBar != "undefined") {
                    $(slideWrapper).find('.slick-current').removeClass('loading-bar');
                }
                $(slideWrapper).find(".slide-image").removeClass('first-zoomin');
                $(slideWrapper).find(".slide-image").removeClass('first-scale');

                $(slideWrapper).find(':focus').blur();

                if ($('#shopify-section-' + sectionId + ' .count-current').length) {
                    var slickInstance = $(slideWrapper).slick('getSlick');
                    var slidesToShow = slickInstance ? slickInstance.options.slidesToShow : 1;
                    var pageTotal = parseInt($('#shopify-section-' + sectionId + ' .count-next').data('total'), 10);
                    var page = Math.floor((nextSlide || 0) / slidesToShow) + 1;
                    var pageNext = page + 1;
                    var pageStr = page.toString().padStart(2, '0');
                    var pageNextStr = pageNext.toString().padStart(2, '0');
                    $('#shopify-section-' + sectionId + ' .count-current').text(pageStr);
                    if (pageNext > pageTotal) {
                        $('#shopify-section-' + sectionId + ' .count-next').text('01');
                    } else {
                        $('#shopify-section-' + sectionId + ' .count-next').text(pageNextStr);
                    }
                }
                if ($('#shopify-section-' + sectionId + ' .direction-dots').length) {
                    $('#shopify-section-' + sectionId + ' .direction-dots').removeClass('act');
                }
            });
            $(slideWrapper).on("afterChange", function(event, slick, currentSlide) {
                $(".caption-animate", '.slick-current').each(function() {
                    var caption = $(this).data("animate");
                    $(this).addClass(caption);
                });
                if (zoom == true) {
                    $(slideWrapper).find(".slick-current .slide-image").addClass("zoom_img");
                }
                if (autoplay == true && typeof loadingBar != "undefined") {
                    $(slideWrapper).find('.slick-current').addClass('loading-bar');
                }
                $(slideWrapper).find('.slick-slide').attr('inert', 'true').attr('aria-hidden', 'true');
                $(slideWrapper).find('.slick-current').removeAttr('inert').attr('aria-hidden', 'false');

                $(slideWrapper).find('video').trigger('pause');
                $(slideWrapper).find('.slick-current video').trigger('play');
                if ($('#shopify-section-' + sectionId + ' .direction-dots').length) {
                    $('#shopify-section-' + sectionId + ' .direction-dots').addClass('act');
                }

                slick = $(slick.$slider);
            });
            $(slideWrapper).slick({
                nextArrow: '<div class="arrow-next"></div>',
                prevArrow: '<div class="arrow-prev"></div>',
                autoplay: autoplay,
                autoplaySpeed: speed,
                lazyLoad: "progressive",
                pauseOnHover: false,
                pauseOnFocus: false,
                speed: 600,
                fade: true,
                arrows: arrows,
                dots: dots,
                cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)",
                rtl: rtl,
                adaptiveHeight: true,
                appendDots: $('#shopify-section-' + sectionId + ' .append-dots').length ? $('#shopify-section-' + sectionId + ' .append-dots') : slideWrapper
            });
            $('.nav-prev, .count-current', '#shopify-section-' + sectionId).click(function(){
               $(slideWrapper).slick('slickPrev');
            });
            $('.nav-next, .count-next', '#shopify-section-' + sectionId).click(function(){
               $(slideWrapper).slick('slickNext');
            })
        });
    }
    return Nov_SliderShow;
})();
theme.Nov_Swipercarousel = (function () {
    function Nov_Swipercarousel(container) {
        var $container = $(container);
        var sectionId = $container.attr("data-section-id");
        var nov_slider = "#shopify-section-" + sectionId + " .nov-swiper-carousel";
        var items_xxl = $(nov_slider).data("items_xxl") || 4;
        var items_xl = $(nov_slider).data("items_xl") || 4;
        var items_lg = $(nov_slider).data("items_lg") || 3;
        var items_md = $(nov_slider).data("items_md") || 3;
        var items_sm = $(nov_slider).data("items_sm") || 2;
        var items_xs = $(nov_slider).data("items_xs") || 2;
        var row_number = $(nov_slider).data("row") || 1;
        var row_mobile = $(nov_slider).data("row_mobile") || 1;
        var loop = $(nov_slider).data("loop") || false;
        var spacing = $(nov_slider).data("spacing");
        var spacing_mobile = $(nov_slider).data("spacing_mobile");
        var nextButton = "#shopify-section-" + sectionId + " .nav-next";
        var prevButton = "#shopify-section-" + sectionId + " .nav-prev";
        var pagination = "#shopify-section-" + sectionId + " .swiper-pagination";
        var scrollbar = $container.find(".nov-swiper-carousel .swiper-scrollbar")[0];

        var gridConfigDesktop = row_number > 1 ? { rows: row_number, fill: "row" } : 1;
        var gridConfigMobile = row_mobile > 1 ? { rows: row_mobile, fill: "row" } : 1;

        var swiper = new Swiper(nov_slider, {
            slidesPerView: items_xs,
            slidesPerGroup: loop ? 1 : items_xs,
            spaceBetween: spacing_mobile,
            watchSlidesProgress: true,
            loop: loop,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            pagination: {
                el: pagination,
                type: "bullets",
                clickable: true,
            },
            scrollbar: {
                el: scrollbar,
                draggable: true,
            },
            grid: gridConfigMobile,
            breakpoints: {
                100: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    grid: gridConfigMobile,
                },
                320: {
                    slidesPerView: items_xs,
                    slidesPerGroup: loop ? 1 : items_xs,
                    spaceBetween: spacing_mobile,
                    grid: gridConfigMobile,
                },
                576: {
                    slidesPerView: items_sm,
                    slidesPerGroup: loop ? 1 : items_sm,
                    spaceBetween: spacing_mobile,
                    grid: gridConfigMobile,
                },
                768: {
                    slidesPerView: items_md,
                    slidesPerGroup: loop ? 1 : items_md,
                    spaceBetween: spacing,
                    grid: gridConfigDesktop,
                },
                992: {
                    slidesPerView: items_lg,
                    slidesPerGroup: loop ? 1 : items_lg,
                    spaceBetween: spacing,
                    grid: gridConfigDesktop,
                },
                1200: {
                    slidesPerView: items_xl,
                    slidesPerGroup: loop ? 1 : items_xl,
                    spaceBetween: spacing,
                    grid: gridConfigDesktop,
                },
                1441: {
                    slidesPerView: items_xxl,
                    slidesPerGroup: loop ? 1 : items_xxl,
                    spaceBetween: spacing,
                    grid: gridConfigDesktop,
                },
            },
            simulateTouch: true,
            touchEventsTarget: 'container'
        });

        var isNavigating = false;
        function handleNavigationClick(event) {
            if (isNavigating) return;
            isNavigating = true;
            nextBtn.style.pointerEvents = "none";
            prevBtn.style.pointerEvents = "none";
            setTimeout(() => {
                isNavigating = false;
                nextBtn.style.pointerEvents = "auto";
                prevBtn.style.pointerEvents = "auto";
            }, 400);
        }
        var nextBtn = document.querySelector(nextButton);
        var prevBtn = document.querySelector(prevButton);
        if (nextBtn) nextBtn.addEventListener("click", handleNavigationClick);
        if (prevBtn) prevBtn.addEventListener("click", handleNavigationClick);
    }
    return Nov_Swipercarousel;
})();
$(document).ready(function() {
    var sections = new theme.Sections();
    sections.register('slideshow-section', theme.Nov_SliderShow);
    sections.register("nov-swiper", theme.Nov_Swipercarousel);
    theme.Nov_Slickcarousel();
    theme.customerTemplates.init();
    theme.customerloginTemplates.init();
    $('a[href="#"]').on('click', function(evt) {
        evt.preventDefault();
    });
});